import { useCallback } from "react";
import { useKnownUser } from "../user-context";
import { getItemAsObject, setItem } from "../../utils/local-storage";
import { hash } from "../../utils/string";

/**
 *  Create localStorage entries scoped by user. Will add/remove fields
 *  to an object keyed by e.g. crane_213980234984
 */
export default function useLocalStorage() {
  const user = useKnownUser();
  const mainKey = `crane_${hash(user.email)}`;

  const getCurrentDataForUser = useCallback(() => {
    return getItemAsObject(mainKey) || {};
  }, [mainKey]);

  const set = useCallback(
    (key, val) => {
      const allData = getCurrentDataForUser();
      allData[key] = val;
      setItem(mainKey, allData);
    },
    [mainKey, getCurrentDataForUser]
  );

  const get = useCallback(
    key => {
      const allData = getCurrentDataForUser();
      return allData[key];
    },
    [getCurrentDataForUser]
  );

  const remove = useCallback(
    key => {
      const allData = getCurrentDataForUser();
      if (allData[key]) {
        delete allData[key];
        setItem(mainKey, allData);
      }
    },
    [mainKey, getCurrentDataForUser]
  );

  return {
    set,
    get,
    remove,
  };
}
